<template>

    <section class="featured-used bottom-space">
        <div class="ink-grid">

            <div class="content vertical-padding">

                <h2 class="section-title text-center">Usados em destaque</h2>

                <div class="column-group gutters">
                    <div class="tiny-100 small-100 medium-50 large-25 xlarge-25" v-for="n in 8">
                        <VehicleCard usedVehicle></VehicleCard>
                    </div>
                </div>

                <div class="ink-flex push-center">
                    <a href="/carros-usados" class="ink-button">Procurar carro usado</a>
                </div>

            </div>

        </div>
    </section>

</template>

<script>
    import VehicleCard from '../shared/vehicle-card.vue'

    export default {

        components: {
            VehicleCard
        },

    };
</script>
